import React from "react";
import ReportsView from "../../components/views/reports-view/ReportsView";

export default function ReportsPage() {
  return <ReportsView />;
}
